import { RestClient } from './RestClient'
import store from 'src/store'

export class PendingInvoiceImportClient extends RestClient {
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/pending-invoice-imports`
  }

  /**
   * Get a list of imported invoices
   *
   * @returns {AxiosPromise}
   */
  list () {
    return this.call('get', this.baseUrl)
  }

  /**
   * Show the specified imported invoices
   *
   * @param {(...number|number[])} id - Imported invoices to show
   *
   * @returns {AxiosPromise}
   */
  get (...id) {
    return this.call('get', `${this.baseUrl}/${this.parseAndJoin(id)}`)
  }

  /**
   * Create a new imported invoice
   *
   * @param {Object} data - Impported invoice data
   *
   * @returns {AxiosPromise}
   */
  create (data) {
    return this.call('post', this.baseUrl, data)
  }

  /**
   * Delete the specified imported invoices
   *
   * @param {(...number|number[])} invoiceId - Imported invoices which should be deleted
   *
   * @returns {AxiosPromise}
   */
  destroy (...invoiceId) {
    return this.call('delete', `${this.baseUrl}/${this.parseAndJoin(invoiceId)}`)
  }

  /**
   * Create an invoice from an imported invoice
   *
   * @param {number} invoiceId - Imported invoices which should be used
   * @param {Object} data - The invoice data
   *
   * @returns {AxiosPromise}
   */
  createInvoice (invoiceId, data) {
    return this.call('post', `${this.baseUrl}/${invoiceId}/create-invoice`, data)
  }
}
